export default __webpack_public_path__ + "static/media/off-19.b62ad029.png";